import { PerspectiveGroupingRule } from '@ardoq/perspectives';
import { actionCreator } from '@ardoq/rxbeach';

export const requestOptionsDataFetch = actionCreator(
  '[PerspectiveEditorData] Request options data fetch'
);

export const groupingRulesApplied = actionCreator<PerspectiveGroupingRule[]>(
  '[PerspectiveEditorData] Grouping rules applied'
);

export const referenceLabelFormattingChanged = actionCreator<string>(
  '[PerspectiveEditorData] Reference label formatting changed'
);
